import styled from 'styled-components';

import HeaderContainer from '../../components/common/HeaderContainer';
import Footer from '../../components/common/Footer';
import ProjectListContainer from '../../components/project/ProjectListContainer';

const ProjectListPage = () => {
    return (
        <Wrapper>
            <div className="header">
                <HeaderContainer />
            </div>
            <Spacer />
            <div className="full-height">
                <ProjectListContainer />
            </div>
            <div className="footer">
                <Footer />
            </div>
        </Wrapper>
    );
};

export default ProjectListPage;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;

    .header {
        flex-shrink: 0; /* 헤더가 유연하게 크기를 조절하지 않도록 설정 */
    }

    .full-height {
        flex-grow: 1; /* 나머지 공간을 모두 차지하도록 설정 */
    }

    .footer {
        flex-shrink: 0; /* 푸터가 유연하게 크기를 조절하지 않도록 설정 */
    }
`;

const Spacer = styled.div`
    margin-top: 3rem;
`;
